import { getStateStore } from '../../stores';
import { checkPlayerActivity } from '../managers/playerActivity';

const state = getStateStore('ipc');

export const initializeInputHandlerEvents = () => {
  state.hostPauseInputState.addListener((newState) => {
    state.pauseInputState.updateState({
      ...state.pauseInputState.currentState,
      paused: newState.paused,
    });
  });

  state.hostInputDominanceState.addListener((newState) => {
    checkPlayerActivity();
  });
};
